import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject
} from "@angular/core";
import { AvailabilityVisitService } from "@app/services/http/availability-visit.service";
import { ActivatedRoute, Router } from "@angular/router";
import { VisitStore } from "@app/services/store/visit-store";
import { Visit_DetailProjection } from "@app/models/rest/visit";
import { AvailabilityVisitRequest } from "@app/models/dto/availability-visit-request";
import { PlanningSegmentStore } from "@app/services/store/planning-segment-store";
import moment from "moment";
import { Moment } from "moment";
import { UntypedFormControl, Validators } from "@angular/forms";
import { AvailabilityInfo } from "@app/models/dto/availability-info";
import { BehaviorSubject } from "rxjs";
import { PlanningSegment } from "@app/models/rest/planning-segment";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { BookingConfirmComponent } from "@app/view/booking/booking-confirm/booking-confirm.component";
import { Ticket_BasicProjection } from "@app/models/rest/ticket";
import { VisitStatus } from "@app/models/enums/visit-status.enum";
import { VisitSchedule } from "@app/models/rest/visit-schedule";
import { ResourceStore } from "@app/services/store/resource-store";
import { ResourceModel } from "@app/models/rest/resource";
import { TicketStore } from "@app/services/store/ticket-store";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService, NgxUiLoaderModule } from "ngx-ui-loader";
import { SolverService } from "@app/services/rest/solver.service";
import { SolverStatus } from "@app/models/dto/solver-status.enum";
import { BookingOutcomeComponent } from "@app/view/booking/booking-outcome/booking-outcome.component";
import { CancelVisitDialogComponent } from "@app/view/jobs/cancel-visit-dialog/cancel-visit-dialog.component";
import { Location, AsyncPipe } from "@angular/common";
import { BookingNavigationService } from "@app/services/navigation/booking-navigation.service";
import { ResourceChooserDialogComponent } from "@app/view/shared/resource-chooser-dialog/resource-chooser-dialog.component";
import { TicketAvailabilityRequest } from "@app/models/dto/ticket-availability-request";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { select, Store } from "@ngrx/store";
import { selectorAuth } from "@app/core";
import { BookPastDueBehaviour } from "@app/models/enums/book-past-due-behaviour";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

import {
  MatList,
  MatListSubheaderCssMatStyler,
  MatListItem
} from "@angular/material/list";
import { MatLine } from "@angular/material/core";
import { MatDivider } from "@angular/material/divider";
import { VisitPropertyListComponentComponent } from "../visit-property-list-component/visit-property-list-component.component";
import { MatGridList, MatGridTile } from "@angular/material/grid-list";
import { AvailabilityInfoDisplayComponent } from "../availability-info-display/availability-info-display.component";
import { MatTooltip } from "@angular/material/tooltip";
import { MomentModule } from "ngx-moment";
import { PropertyService } from "@app/integrations/urm/services/property.service";
import { PropPropertyHeader } from "@app/integrations/urm/models/prop-property-header";

@Component({
  selector: "app-visit-booking",
  templateUrl: "./visit-booking.component.html",
  styleUrls: ["./visit-booking.component.scss"],
  imports: [
    NgxUiLoaderModule,
    MatToolbar,
    MatIconButton,
    MatIcon,
    MatButton,
    MatList,
    MatListSubheaderCssMatStyler,
    MatListItem,
    MatLine,
    MatDivider,
    VisitPropertyListComponentComponent,
    MatGridList,
    MatGridTile,
    AvailabilityInfoDisplayComponent,
    MatTooltip,
    AsyncPipe,
    MomentModule
  ],
  standalone: true
})
export class VisitBookingComponent implements OnInit {
  availabilityService = inject(AvailabilityVisitService);
  visitStore = inject(VisitStore);
  resourceStore = inject(ResourceStore);
  ticketStore = inject(TicketStore);
  planningSegmentStore = inject(PlanningSegmentStore);
  dialog = inject(MatDialog);
  private router = inject(Router);
  private activeRoute = inject(ActivatedRoute);
  serviceErrorHandler = inject(ServiceErrorHandlerService);
  private snackBar = inject(MatSnackBar);
  private ngxLoader = inject(NgxUiLoaderService);
  private location = inject(Location);
  private solverServer = inject(SolverService);
  private store = inject<Store<any>>(Store);
  private clientConfig = inject(ClientConfigService);
  private propertyService = inject(PropertyService);
  private bookingNavigationService = inject(BookingNavigationService);

  @Input()
  public exitOnCompletion: boolean = false;
  public closed: boolean = false;
  visit: Visit_DetailProjection;
  availabilityInfo: AvailabilityInfo[] = [];
  segments: PlanningSegment[] = [];
  availabilitySubject: BehaviorSubject<AvailabilityInfo[]>;
  date = new UntypedFormControl(moment().isoWeekday(1));
  // public loading: boolean = true;
  public calculating: boolean = true;
  bestAppointmentShown: boolean;
  slotObservables: BehaviorSubject<AvailabilityInfo>[][] = [];
  public selectedDate: Moment = moment().isoWeekday(1);
  isNextWeekValid: boolean;
  isPreviousWeekValid: boolean;
  ticketData: MatTableDataSource<Ticket_BasicProjection>;
  scheduleData: MatTableDataSource<VisitSchedule>;
  VisitStatus = VisitStatus;
  resources: ResourceModel[];
  resourceFormControl: UntypedFormControl[] = [];

  // Properties for indicating visits in other weeks
  public hasVisitsBeforeCurrentWeek: boolean = false;
  public hasVisitsAfterCurrentWeek: boolean = false;
  public visitsInCurrentWeek: Visit_DetailProjection[] = [];
  public slotVisitMap: Map<string, Visit_DetailProjection[]> = new Map();

  // Property details
  public showPropertyAddress: boolean = false;
  public property: PropPropertyHeader = null;
  private loadingProperty: boolean = false;

  @Output()
  booked = new EventEmitter<object>();
  public lastCalculationTime: string;
  public windowClose = false;
  public unsuitable: boolean = false;
  public unsuitableMessage: string =
    "This visit is not at a status suitable for booking.";
  public allowResourceLocking: boolean = true;
  public floatingBookingEnabled: boolean = false;
  currentLoadingMessage: string = "Loading Visit...";
  resourceList: { description: string; ticket: Ticket_BasicProjection }[];
  private allowBookPastDue: boolean = false;
  private allowBookBeforeDue: boolean = false;
  private loadingSegments: boolean = false;

  constructor() {
    this.activeRoute.params.subscribe((params) => {
      if (params && params["id"]) {
        this.visitId = params["id"];
      }
    });
    this.activeRoute.data.subscribe((value) => {
      console.log("route data", value);
      if (value["visitOnlyBooking"]) {
        this.exitOnCompletion = true;
        this.windowClose = true;
      }
    });

    this.store.pipe(select(selectorAuth)).subscribe((auth) => {
      this.allowResourceLocking = !!auth && auth.allowResourceLocking;
    });
  }

  private _visitId: number;

  get visitId(): number {
    return this._visitId;
  }

  @Input()
  set visitId(value: number) {
    this._visitId = value;
    // Reset component state when a new visit is loaded (for multi-visit booking scenarios)
    this.closed = false;
    this.unsuitable = false;
    this.unsuitableMessage =
      "This visit is not at a status suitable for booking.";
    this.calculating = true;
    this.loadVisit();
    // this.ngxLoader.startLoader('bookingLoader', 'confirm');
  }

  get isOverdue(): boolean {
    if (!this.visit) {
      return false;
    }
    return moment(this.visit.job.planningWindowEnd).isBefore(moment());
  }

  ngOnInit() {
    this.currentLoadingMessage = "Loading data";

    // Check if floating booking is enabled in client config
    if (this.clientConfig && this.clientConfig.config) {
      this.floatingBookingEnabled =
        !!this.clientConfig.config.enableFloatingBooking;
    }

    // Store original route if not already stored (for cases where user navigates directly to booking)
    if (!this.bookingNavigationService.hasOriginalRoute()) {
      // Try to determine the referrer route
      const currentUrl = this.router.url;
      if (currentUrl.includes("/booking/launch/")) {
        // This is a standalone booking, no need to store route as exitOnCompletion will handle it
      } else {
        // This is embedded in the main app, store a fallback route
        this.bookingNavigationService.setOriginalRoute("/");
      }
    }

    console.log("init fired");
  }

  getTicketResourceLocks(): TicketAvailabilityRequest[] {
    const ticketOutput: TicketAvailabilityRequest[] = [];
    this.visit.ticketList.forEach((value) => {
      if (
        this.resourceFormControl[value.id] &&
        this.resourceFormControl[value.id].value
      ) {
        ticketOutput.push({
          ticketId: value.id,
          resourceId: this.resourceFormControl[value.id].value.id
        });
      }
    });
    return ticketOutput;
  }

  /**
   * Check if a resource is already locked to another ticket
   * @param resourceId The resource ID to check
   * @param excludeTicketId The ticket ID to exclude from the check (the current ticket being set)
   * @returns true if the resource is already locked to another ticket
   */
  isResourceLockedToAnotherTicket(
    resourceId: number,
    excludeTicketId: number
  ): boolean {
    if (!this.visit || !this.visit.ticketList) {
      return false;
    }
    return this.visit.ticketList.some((ticket) => {
      if (ticket.id === excludeTicketId) {
        return false;
      }
      const formControl = this.resourceFormControl[ticket.id];
      return (
        formControl && formControl.value && formControl.value.id === resourceId
      );
    });
  }

  /**
   * Check if there are any duplicate resource locks across tickets
   * @returns true if duplicate resource locks exist
   */
  hasDuplicateResourceLocks(): boolean {
    if (!this.visit || !this.visit.ticketList) {
      return false;
    }
    const lockedResourceIds: number[] = [];
    for (const ticket of this.visit.ticketList) {
      const formControl = this.resourceFormControl[ticket.id];
      if (formControl && formControl.value) {
        const resourceId = formControl.value.id;
        if (lockedResourceIds.includes(resourceId)) {
          return true;
        }
        lockedResourceIds.push(resourceId);
      }
    }
    return false;
  }

  /**
   * Get the name of the resource that is duplicated (if any)
   * @returns The name of the duplicated resource, or null if no duplicates
   */
  getDuplicateResourceName(): string | null {
    if (!this.visit || !this.visit.ticketList) {
      return null;
    }
    const seenResources: Map<number, string> = new Map();
    for (const ticket of this.visit.ticketList) {
      const formControl = this.resourceFormControl[ticket.id];
      if (formControl && formControl.value) {
        const resourceId = formControl.value.id;
        const resourceName = formControl.value.name;
        if (seenResources.has(resourceId)) {
          return resourceName;
        }
        seenResources.set(resourceId, resourceName);
      }
    }
    return null;
  }

  recalculate() {
    this.availabilityService.clearPendingRequest();
    let startTime = moment();
    let currentDate = moment(this.selectedDate).startOf("day");
    let endDate = moment(currentDate).startOf("day").add(7, "day");
    if (currentDate.isBefore(moment(), "day")) {
      currentDate = moment();
    }
    if (
      !this.allowBookBeforeDue &&
      currentDate.isBefore(this.visit.job.planningWindowStart)
    ) {
      currentDate = moment(this.visit.job.planningWindowStart);
    }

    if (
      !this.allowBookPastDue &&
      moment(this.visit.job.planningWindowEnd).isBefore(endDate)
    ) {
      endDate = moment(this.visit.job.planningWindowEnd);
    }

    if (endDate.isBefore(startTime)) {
      this.calculating = false;
      this.serviceErrorHandler.handleClientError(
        "Cannot book this job as the planning window has expired."
      );
      return;
    }

    // Set calculating to true so loading indicators appear
    this.calculating = true;

    // Reset all slot data to null to force reload
    this.segments.forEach((segment: PlanningSegment) => {
      [0, 1, 2, 3, 4, 5, 6].forEach((day) => {
        this.getObservable(day, segment).next(null);
      });
    });

    // Force a change detection cycle
    setTimeout(() => {}, 0);
    this.lastCalculationTime = "";

    let availabilityRequest: AvailabilityVisitRequest = {
      visitId: this.visit.id,
      startDate: currentDate.parseZone().toDate(),
      endDate: endDate.parseZone().toDate(),
      tickets: this.getTicketResourceLocks()
    };

    this.availabilityService
      .getAvailabilityForVisit(availabilityRequest)
      .then((value) => {
        console.log(value);
        if (!value) {
          return;
        }
        // Store the availability info and update the slots
        this.availabilityInfo = value.availabilityInfoList;
        this.availabilitySubject.next(this.availabilityInfo);

        // Set calculating to false after slots are updated
        this.calculating = false;

        this.lastCalculationTime = `Calculated ${
          this.availabilityInfo.length
        } slots in ${moment().diff(startTime, "milliseconds")} ms`;
      })
      .catch((error) => {
        console.log("availability call error", error);
        this.segments.forEach((segment: PlanningSegment) => {
          [0, 1, 2, 3, 4, 5, 6].forEach((day) => {
            this.getObservable(day, segment).next({
              feasible: false,
              best: false,
              planningSegmentId: segment.id,
              rank: -1,
              endTime: null,
              startTime: null,
              effects: [],
              preferred: false,
              score: null
            });
          });
        });
        this.serviceErrorHandler.handleError(error);
      });
  }

  getAvailabilityForVisit(visitId: number) {
    // this.loading = true;
    // this.ngxLoader.startLoader('bookingLoader', 'confirm');
    this.calculating = true;
    this.visit = null;
    this.resourceStore
      .loadAll({ params: { projection: "detail" } })
      .then((resources) => {
        this.resources = resources.resources;

        this.visitStore
          .loadSingleWithSearch("findVisitByIdEquals", {
            params: {
              projection: "detail",

              id: visitId
            }
          })
          .then((halVisit: Visit_DetailProjection) => {
            this.visit = halVisit;

            // Check if URM services are enabled
            if (
              this.clientConfig.config.urmServices?.enabled &&
              this.visit.job?.externalPropertyReference
            ) {
              this.showPropertyAddress = true;
              this.loadPropertyDetails(
                this.visit.job.externalPropertyReference
              );
            } else {
              this.showPropertyAddress = false;
            }

            this.allowBookPastDue = this.clientConfig.config.bookPastDue;
            if (
              this.visit.job.priority.bookPastDueBehaviour &&
              this.visit.job.priority.bookPastDueBehaviour !==
                BookPastDueBehaviour.DEFAULT
            ) {
              if (
                this.visit.job.priority.bookPastDueBehaviour ===
                BookPastDueBehaviour.ALLOW
              ) {
                this.allowBookPastDue = true;
              } else if (
                this.visit.job.priority.bookPastDueBehaviour ===
                BookPastDueBehaviour.DENY
              ) {
                this.allowBookPastDue = false;
              }
            }
            console.log("Visit book past due", this.allowBookPastDue);
            this.allowBookBeforeDue = false;
            if (
              this.visit.job.priority.bookBeforeDueBehaviour &&
              this.visit.job.priority.bookBeforeDueBehaviour !==
                BookPastDueBehaviour.DEFAULT
            ) {
              if (
                this.visit.job.priority.bookBeforeDueBehaviour ===
                BookPastDueBehaviour.ALLOW
              ) {
                this.allowBookBeforeDue = true;
              } else if (
                this.visit.job.priority.bookBeforeDueBehaviour ===
                BookPastDueBehaviour.DENY
              ) {
                this.allowBookBeforeDue = false;
              }
            }

            if (
              halVisit.visitStatus === VisitStatus.CANCELLED ||
              halVisit.visitStatus === VisitStatus.IN_PROGRESS ||
              halVisit.visitStatus === VisitStatus.COMPLETED
            ) {
              this.calculating = false;
              this.unsuitable = true;
            }

            // Orchestrator/project visits must not be booked or rebooked in
            // Resolve — all appointment changes happen in Orchestrator (#1530).
            // The unsuitable message replaces the whole booking page, so skip
            // slot/availability initialisation entirely.
            if (halVisit.job?.externalProjectReference) {
              this.calculating = false;
              this.unsuitable = true;
              this.unsuitableMessage =
                "This visit is managed by Orchestrator. Book, rebook or cancel it in Orchestrator.";
              return;
            }

            this.initSlotObservables();
            this.calculateDateNavigationValidity(this.selectedDate);
            this.ticketData = new MatTableDataSource(this.visit.ticketList);
            this.scheduleData = new MatTableDataSource(
              this.visit.visitScheduleList
            );
            // this.ngxLoader.stopLoader("bookingLoader", "confirm");
            // this.loading = false;
            this.recalculate();
            console.log(this.visit.ticketList);

            this.resourceList = [];
            this.visit.ticketList.forEach((value, index) => {
              this.resourceList.push({
                description: "Resource " + (index + 1),
                ticket: value
              });
            });

            this.visit.ticketList.forEach((ticket) => {
              console.log("visit ticket", ticket);
              if (!this.resourceFormControl[ticket.id]) {
                // When rebooking (visit already has an appointment), don't pre-populate locks
                // to allow the solver to find the best resources for the new slot
                const isRebooking =
                  this.visit.appointmentStart !== null ||
                  this.visit.visitStatus === VisitStatus.BOOKED ||
                  this.visit.visitStatus === VisitStatus.FLOATING;
                this.resourceFormControl[ticket.id] = new UntypedFormControl(
                  isRebooking ? null : ticket.lockToResource,
                  Validators.nullValidator
                );
              }
            });
          });
      });
  }

  public isDayValid(day: number): boolean {
    return moment(this.date.value)
      .add(day, "day")
      .isAfter(moment().startOf("day"));
  }

  public getDay(day: number): string {
    return moment(this.date.value).add(day, "day").format("dddd");
  }

  public isToday(day: number): boolean {
    return moment(this.date.value).add(day, "day").isSame(moment(), "day");
  }

  public isOverdueDay(day: number): boolean {
    if (!this.visit || !this.visit.job) return false;
    return (
      moment(this.date.value)
        // return true;
        .add(day, "day")
        .isAfter(this.visit.job.planningWindowEnd, "day")
    );
  }

  public isOverdueDayString(day: number): string {
    if (!this.visit || !this.visit.job) return null;

    if (
      moment(this.date.value)
        // return true;
        .add(day, "day")
        .isAfter(moment(this.visit.job.planningWindowEnd), "day")
    ) {
      return "(Overdue)";
    }
    if (
      moment(this.date.value)
        // return true;
        .add(day, "day")
        .isSame(this.visit.job.planningWindowEnd, "day")
    ) {
      return "Due " + moment(this.visit.job.planningWindowEnd).format("HH:mm");
    }
    //
    return null;
  }

  isDueDate(day: number): boolean {
    if (!this.visit || !this.visit.job) return false;
    return (
      moment(this.date.value)
        // return true;
        .add(day, "day")
        .isSame(this.visit.job.planningWindowEnd, "day")
    );
  }

  public getDate(day: number): string {
    return moment(this.date.value).add(day, "day").format("Do MMMM");
  }

  public selectSlot(
    planningSegment: PlanningSegment,
    day: number,
    slotObservableElement: BehaviorSubject<AvailabilityInfo>
  ) {
    if (!slotObservableElement.getValue()) {
      return;
    }
    const dialogRef = this.dialog.open(BookingConfirmComponent, {
      width: "450px",
      data: {
        mode: "EDIT",
        visit: this.visit,
        segment: planningSegment,
        day: day,
        availabilityInfo: slotObservableElement.getValue()
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
      console.log(result);
      if (result && result.result === true) {
        console.log("slot selected");
        // this.ngxLoader.start('confirmLoading');
        this.currentLoadingMessage = "Confirming booking...";
        this.ngxLoader.startLoader("bookingLoader", "confirm");
        let bookingSolveStarted = false;
        this.solverServer.updateStream.subscribe((value) => {
          if (
            value.status === SolverStatus.RUNNING // &&
            // value.solveReason === SolveReason.BOOKING
          ) {
            this.currentLoadingMessage = "Booking solver begun..";
            bookingSolveStarted = true;
          } else if (
            value.status === SolverStatus.SLEEPING &&
            //  value.solveReason === SolveReason.BOOKING &&
            bookingSolveStarted
          ) {
            this.currentLoadingMessage =
              "Booking solve complete, awaiting outcome..";
          }
        });
        // this.loading = true;
        this.calculating = true;
        this.availabilityService
          .bookVisit({
            visitId: this.visit.id,
            startTime: moment(slotObservableElement.getValue().startTime)
              .parseZone()
              .toDate(),
            endTime: moment(slotObservableElement.getValue().endTime)
              .parseZone()
              .toDate(),
            force: result.force,
            bookingReasonId: result.bookingReasonId,
            notes: result.notes,
            displayedSlotRanking: slotObservableElement.getValue().rank,
            cancel: false,
            refer: false,
            tickets: this.getTicketResourceLocks()
          })
          .then((response) => {
            this.ngxLoader.stopLoader("bookingLoader", "confirm");
            let bookingOutcomeRef = this.dialog.open(BookingOutcomeComponent, {
              data: {
                success: response.success,
                message: response.message
              }
            });
            bookingOutcomeRef.afterClosed().subscribe(() => {
              console.log(response.success);
              if (response.success) {
                this.closed = true; // Mark as closed to prevent further interactions
                this.booked.emit({ booked: true });
                this.ngxLoader.stopLoader("bookingLoader", "confirm");

                if (this.exitOnCompletion) {
                  if (this.windowClose) {
                    console.log("Window is closing");
                    window.close();
                  }
                } else {
                  // Use setTimeout to ensure the navigation happens after the current execution
                  setTimeout(() => {
                    this.bookingNavigationService.returnToOriginalRoute();
                    this.bookingNavigationService.clearOriginalRoute();
                  }, 100);
                }
              } else {
                this.ngOnInit(); // Only reload the component if booking failed
              }
            });
          })
          .catch((reason) => {
            let bookingOutcomeRef = this.dialog.open(BookingOutcomeComponent, {
              data: {
                success: false,
                message: reason
              }
            });
            bookingOutcomeRef.afterClosed().subscribe(() => {
              this.booked.emit({ booked: false });
              this.ngxLoader.stopLoader("bookingLoader", "confirm");
            });
          });
      }
    });
  }

  previousWeek() {
    let momentDate: Moment = moment(this.date.value);
    let newDate: Moment = moment(momentDate.add(-7, "day"));
    this.date.setValue(newDate);
    this.selectedDate = newDate;
    this.calculateDateNavigationValidity(newDate);
    this.recalculate();
    this.clearSlotVisitMap();
  }

  calculateDateNavigationValidity(datePicked: Moment) {
    console.log("Checking date navigation validity for ", datePicked);
    this.isPreviousWeekValid =
      moment(this.visit.job.planningWindowStart).isBefore(datePicked) &&
      moment().isBefore(datePicked);
    if (!this.allowBookPastDue) {
      this.isNextWeekValid = true;
    } else {
      this.isNextWeekValid = moment(this.visit.job.planningWindowEnd).isBefore(
        moment(datePicked).add(7, "day")
      );
    }

    moment(this.visit.job.planningWindowEnd);
  }

  nextWeek() {
    let momentDate: Moment = moment(this.date.value);
    let newDate: Moment = moment(momentDate.add(7, "day"));
    this.date.setValue(newDate);
    this.selectedDate = newDate;
    this.calculateDateNavigationValidity(newDate);
    this.recalculate();
    this.clearSlotVisitMap();
  }

  cancelVisit() {
    this.dialog.open(CancelVisitDialogComponent, {
      data: { visit: this.visit }
    });
  }

  returnToMenu() {
    this.router.navigate(["../booking"]);
  }

  switchToFloatingBooking() {
    // Check if floating booking is enabled
    if (!this.floatingBookingEnabled) {
      this.snackBar.open("Floating booking is currently disabled", "Close", {
        duration: 3000
      });
      return;
    }

    // Preserve the current routing context based on how this component was loaded
    if (this.exitOnCompletion) {
      this.router.navigate([`/booking/launch/visit/${this.visitId}/floating`]);
    } else {
      // When embedded in the main app, use relative navigation
      this.router.navigate([`floating`], { relativeTo: this.activeRoute });
    }
  }

  getCurrentResourceOptions(param: any) {
    console.log(param);
  }

  // Check if a slot is valid for displaying and updating
  isSlotValid(day: number, segment: PlanningSegment): boolean {
    // Check if this specific day/segment combination is valid
    let validForSegment = true;
    switch (day) {
      case 0:
        validForSegment = segment.monday;
        break;
      case 1:
        validForSegment = segment.tuesday;
        break;
      case 2:
        validForSegment = segment.wednesday;
        break;
      case 3:
        validForSegment = segment.thursday;
        break;
      case 4:
        validForSegment = segment.friday;
        break;
      case 5:
        validForSegment = segment.saturday;
        break;
      case 6:
        validForSegment = segment.sunday;
        break;
    }

    // Check booking window rules
    if (!this.allowBookPastDue) {
      if (
        moment(this.date.value)
          .add(day, "day")
          .isAfter(this.visit.job.planningWindowEnd)
      ) {
        console.log(
          "Booking past due is not allowed for slot",
          day,
          "of segment",
          segment.id
        );
        validForSegment = false;
      }
    }
    if (!this.allowBookBeforeDue) {
      // Check if the date is before the planning window start

      if (
        moment(this.date.value)
          .add(day, "day")
          .isBefore(this.visit.job.planningWindowStart)
      ) {
        console.log(
          "Booking before due is not allowed for slot",
          day,
          "of segment",
          segment.id,
          "with planning window start",
          this.visit.job.planningWindowStart
        );
        validForSegment = false;
      }
    }

    // Check if time is in the past
    let endTime = moment(this.date.value)
      .startOf("day")
      .add(day, "day")
      .add(segment.startHour, "hour")
      .add(segment.startMinute + segment.duration, "minute");

    if (!moment().isBefore(endTime)) {
      validForSegment = false;
    }

    console.log(
      "Valid for segment",
      segment,
      "on day",
      day,
      ":",
      validForSegment
    );

    return validForSegment;
  }

  willCalculate(day: number, segment: PlanningSegment) {
    // If we're not in calculating state, nothing should be loading

    if (!this.calculating) {
      return false;
    }

    // Only show loading indicator for valid segments that haven't loaded yet
    return (
      this.isSlotValid(day, segment) &&
      this.getObservable(day, segment).getValue() === null
    );
  }

  clearSelection(ticket: Ticket_BasicProjection) {
    this.ticketStore.loadSingle(ticket.id).then((storedTicket) => {
      storedTicket.unbindRelation("lockToResource").subscribe(() => {
        console.log("set");
        // this.ngOnInit();
        this.resourceFormControl[ticket.id].setValue(null);

        this.loadVisit();
      });
    });
  }

  getObservable(pos: number, segment: PlanningSegment) {
    if (!this.slotObservables[segment.id]) {
      this.slotObservables[segment.id] = [];
      this.slotObservables[segment.id][pos] = new BehaviorSubject(null);
    }
    if (!this.slotObservables[segment.id][pos]) {
      this.slotObservables[segment.id][pos] = new BehaviorSubject(null);
    }
    return this.slotObservables[segment.id][pos];
  }

  refreshSlots() {
    this.recalculate();
  }

  openReferralForm() {
    const dialogRef = this.dialog.open(BookingConfirmComponent, {
      width: "450px",
      data: {
        mode: "EDIT",
        visit: this.visit,
        referralMode: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Got result: ", result);
      if (result && result.result) {
        this.availabilityService
          .bookVisit({
            visitId: this.visit.id,
            startTime: null,
            endTime: null,
            force: false,
            bookingReasonId: result.bookingReasonId,
            notes: result.notes,
            displayedSlotRanking: null,
            refer: true,
            cancel: false,
            tickets: null
          })
          .then((response) => {
            this.ngxLoader.stopLoader("bookingLoader", "confirm");
            let bookingOutcomeRef = this.dialog.open(BookingOutcomeComponent, {
              data: {
                success: response.success,
                message: response.message,
                mode: "REFER"
              }
            });
            bookingOutcomeRef.afterClosed().subscribe(() => {
              console.log(response.success);
              if (response.success) {
                if (this.exitOnCompletion) {
                  console.log("Exit on completion mode");
                  if (this.windowClose) {
                    console.log("Window is closing");
                    window.close();
                  }
                  this.booked.emit({ booked: true });
                  // this.closed = true;
                  this.ngxLoader.stopLoader("bookingLoader", "confirm");
                  this.ngOnInit();
                } else {
                  this.bookingNavigationService.returnToOriginalRoute();
                  this.bookingNavigationService.clearOriginalRoute();
                }
              } else {
                this.ngOnInit();
              }
            });
          })
          .catch(() => {
            let bookingOutcomeRef = this.dialog.open(BookingOutcomeComponent, {
              data: {
                success: false,
                message: "Error in booking service call"
              }
            });
            bookingOutcomeRef.afterClosed().subscribe(() => {
              this.booked.emit({ booked: false });
              this.ngxLoader.stopLoader("bookingLoader", "confirm");
            });
          });
      }
    });
  }

  selectResource(ticket: Ticket_BasicProjection) {
    const skills = [];
    ticket?.skillProfile?.skillRuleList?.forEach((skillRule) => {
      skills.push(skillRule.skill.id);
    });
    const dialogRef = this.dialog.open(ResourceChooserDialogComponent, {
      data: {
        requiredZoneId: this.visit?.job?.zone?.id,
        requiredSkillIds: skills
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed", result);
      if (result && result.data) {
        // Check if this resource is already locked to another ticket
        if (this.isResourceLockedToAnotherTicket(result.data.id, ticket.id)) {
          this.snackBar.open(
            `Resource '${result.data.name}' is already locked to another ticket on this visit`,
            "Close",
            { duration: 5000 }
          );
          return;
        }
        this.resourceFormControl[ticket.id].setValue(result.data);
        this.loadVisit();
      }
    });
  }

  saveNote() {}

  private initSlotObservables() {
    let startTime = moment();
    let currentDate = moment(this.selectedDate).startOf("day");
    let endDate = moment(currentDate).startOf("day").add(7, "day");
    if (currentDate.isBefore(moment(), "day")) {
      currentDate = moment();
    }

    if (
      !this.allowBookPastDue &&
      moment(this.visit.job.planningWindowEnd).isBefore(endDate)
    ) {
      endDate = moment(this.visit.job.planningWindowEnd);
    }

    if (endDate.isBefore(startTime)) {
      this.calculating = false;
      // this.serviceErrorHandler.handleClientError("Cannot book this job as the planning window has expired.");
      return;
    }

    if (this.segments && this.segments.length > 0 && !this.loadingSegments) {
      this.segments.forEach((value1) => {
        this.slotObservables[value1.id] = [];
        [0, 1, 2, 3, 4, 5, 6].forEach((dayIndex) => {
          this.slotObservables[value1.id][dayIndex] = new BehaviorSubject(null);
          console.log(this.slotObservables[value1.id][dayIndex]);
        });
      });
    } else {
      this.loadingSegments = true;
      this.availabilityService
        .getSegments(this.visit.job.priority.id)
        .then((validSegments) => {
          console.log("Valid segments", validSegments);
          this.segments = validSegments;
          this.loadingSegments = false;
          this.segments.forEach((value1) => {
            this.slotObservables[value1.id] = [];
            [0, 1, 2, 3, 4, 5, 6].forEach((dayIndex) => {
              this.slotObservables[value1.id][dayIndex] = new BehaviorSubject(
                null
              );
              console.log(this.slotObservables[value1.id][dayIndex]);
            });
          });
        });
    }
  }

  private loadVisit() {
    console.log("visit id changed to " + this.visitId);
    this.availabilitySubject = new BehaviorSubject<AvailabilityInfo[]>([]);

    this.availabilitySubject.asObservable().subscribe((infoList) => {
      this.updateSlots(infoList);
    });

    this.getAvailabilityForVisit(this.visitId);

    this.date.valueChanges.subscribe(() => {
      this.selectedDate = moment(this.date.value);
      this.selectedDate = this.selectedDate.isoWeekday(1);
      this.updateSlots(this.availabilitySubject.getValue());
    });
  }

  private updateSlots(infoList: AvailabilityInfo[]) {
    console.log("update slots called", infoList);
    if (infoList.length === 0) {
      return;
    }
    this.slotObservables.forEach((value) => {
      value.forEach((value1) => {
        value1.next(null);
      });
    });
    if (infoList.length === 0) {
      return;
    }
    this.segments.forEach((segment: PlanningSegment) => {
      [0, 1, 2, 3, 4, 5, 6].forEach((day) => {
        let currentDate = moment(this.date.value)
          .add(day, "day")
          .startOf("day");
        infoList.forEach((value) => {
          if (value.planningSegmentId === segment.id) {
            let infoDate = moment(value.startTime).startOf("day");
            console.log(
              "compare " +
                infoDate.parseZone().toDate() +
                " to " +
                currentDate.parseZone().toDate()
            );
            if (currentDate.isSame(infoDate)) {
              console.log("match");

              this.getObservable(day, segment).next(value);
            }
          }
        });
      });
    });
  }

  public startTimeString(segment: PlanningSegment) {
    return (
      segment.startHour.toString(10).padStart(2, "0") +
      ":" +
      segment.startMinute.toString(10).padStart(2, "0")
    );
  }

  public endTimeString(segment: PlanningSegment) {
    let startMinutesTotal = segment.startHour * 60 + segment.startMinute;
    startMinutesTotal += segment.duration;

    let hours = Math.floor(startMinutesTotal / 60);
    let minutes = Math.floor(startMinutesTotal % 60);

    let hourString = (hours % 24) + "";
    let minuteString = minutes + "";
    return hourString.padStart(2, "0") + ":" + minuteString.padStart(2, "0");
  }

  /**
   * Handle notification of visits before the current week
   */
  onHasVisitsBeforeWeek(hasVisits: boolean): void {
    this.hasVisitsBeforeCurrentWeek = hasVisits;
  }

  /**
   * Handle notification of visits after the current week
   */
  onHasVisitsAfterWeek(hasVisits: boolean): void {
    this.hasVisitsAfterCurrentWeek = hasVisits;
  }

  /**
   * Process visits in the current week to identify matching slots
   */
  onVisitsInWeek(visits: Visit_DetailProjection[]): void {
    this.visitsInCurrentWeek = visits;
    this.mapVisitsToSlots();
  }

  /**
   * Maps visits to available slots based on day and time
   */
  private mapVisitsToSlots(): void {
    this.clearSlotVisitMap();

    if (
      !this.segments ||
      !this.visitsInCurrentWeek ||
      this.visitsInCurrentWeek.length === 0
    ) {
      return;
    }

    // Only process non-floating visits
    const nonFloatingVisits = this.visitsInCurrentWeek.filter(
      (v) => v.visitStatus !== "FLOATING"
    );

    console.log("Mapping visits to slots:", nonFloatingVisits);

    for (const visit of nonFloatingVisits) {
      if (!visit.appointmentStart) continue;

      const visitStart = moment(visit.appointmentStart);
      const visitDay = visitStart.day(); // This gives 0 for Sunday, 1 for Monday, etc.
      const adjustedDay = (visitDay + 6) % 7; // Convert to 0 for Monday, 6 for Sunday
      const visitHour = visitStart.hour();
      const visitMinute = visitStart.minute();

      console.log(
        `Visit ${visit.job?.externalJobReference} on day ${adjustedDay} at ${visitHour}:${visitMinute}`
      );

      // Try to find a matching segment
      let matchFound = false;

      for (const segment of this.segments) {
        // Check if start hour/minute approximately matches the segment
        if (
          Math.abs(segment.startHour - visitHour) <= 1 &&
          Math.abs(segment.startMinute - visitMinute) <= 15
        ) {
          // Create a key for the slot
          const slotKey = `day${adjustedDay}-segment${segment.id}`;
          console.log(`Match found! Adding to slot: ${slotKey}`);

          // Get existing visits for this slot or create a new array
          const existingVisits = this.slotVisitMap.get(slotKey) || [];
          existingVisits.push(visit);
          this.slotVisitMap.set(slotKey, existingVisits);

          matchFound = true;
          break;
        }
      }

      // If no match found for slot, add to the "today" row
      if (!matchFound) {
        const todayKey = `todayRow-day${adjustedDay}`;
        console.log(`No match found. Adding to today row: ${todayKey}`);

        // Get existing visits for this today row or create a new array
        const existingVisits = this.slotVisitMap.get(todayKey) || [];
        existingVisits.push(visit);
        this.slotVisitMap.set(todayKey, existingVisits);
      }
    }

    // For debugging
    console.log(
      "Final slot-visit map:",
      Array.from(this.slotVisitMap.entries())
    );
  }

  /**
   * Clear the slot-visit mapping
   */
  private clearSlotVisitMap(): void {
    this.slotVisitMap = new Map();
  }

  /**
   * Get the number of visits for a slot
   */
  getVisitCountForSlot(day: number, segment: PlanningSegment): number {
    const slotKey = `day${day}-segment${segment.id}`;
    const visits = this.slotVisitMap.get(slotKey);
    return visits ? visits.length : 0;
  }

  /**
   * Get the first visit for a slot (for single visit case)
   */
  getVisitForSlot(
    day: number,
    segment: PlanningSegment
  ): Visit_DetailProjection | null {
    const slotKey = `day${day}-segment${segment.id}`;
    const visits = this.slotVisitMap.get(slotKey);
    return visits && visits.length > 0 ? visits[0] : null;
  }

  /**
   * Get tooltip text for multiple visits in a slot
   */
  getVisitTooltipForMultipleVisits(
    day: number,
    segment: PlanningSegment
  ): string {
    const slotKey = `day${day}-segment${segment.id}`;
    const visits = this.slotVisitMap.get(slotKey) || [];

    return visits
      .map(
        (visit) =>
          `Job: ${visit.job?.externalJobReference} - ${
            visit.visitType?.description || "Visit"
          } - Priority: ${visit.job?.priority?.description}`
      )
      .join("\n\n");
  }

  /**
   * Get visit info for the today row if one exists
   */
  getVisitForTodayRow(day: number): Visit_DetailProjection | null {
    const todayKey = `todayRow-day${day}`;
    const visits = this.slotVisitMap.get(todayKey);
    return visits && visits.length > 0 ? visits[0] : null;
  }

  /**
   * Get the count of visits for today row
   */
  getVisitCountForTodayRow(day: number): number {
    const todayKey = `todayRow-day${day}`;
    const visits = this.slotVisitMap.get(todayKey);
    return visits ? visits.length : 0;
  }

  /**
   * Load property details from property service
   */
  private loadPropertyDetails(propertyRef: string): void {
    if (this.loadingProperty || !propertyRef) return;

    this.loadingProperty = true;
    this.propertyService
      .loadPropertyById(propertyRef)
      .then((propertyData) => {
        this.property = propertyData;
        this.loadingProperty = false;
      })
      .catch((error) => {
        console.error("Error loading property details:", error);
        this.property = null;
        this.loadingProperty = false;
      });
  }

  /**
   * Format property address for display
   * Falls back to just showing property ID if services disabled or call fails
   */
  get propertyAddress(): string {
    const ref = this.visit?.job?.externalPropertyReference || "";

    // Check if URM services are enabled
    if (!this.clientConfig?.config?.urmServices?.enabled) {
      return ref; // Just show the reference if services are disabled
    }

    // If property loaded successfully, format the address
    if (this.property) {
      const addressFields = [
        this.property.Proh_PropertyName,
        this.property.Proh_Address1,
        this.property.Proh_Address2,
        this.property.Proh_Address3,
        this.property.Proh_Address4,
        this.property.Proh_PostCode
      ].filter((field) => field);

      return addressFields.map((field) => `${field}<br/>`).join("");
    }

    // Fallback to just showing the reference
    return ref;
  }
}
